import { fromJS } from 'immutable';

export function request(state, { chatId }) {
    return state
        .setIn([ 'items', chatId, 'state' ], 'IN_PROGRESS');
}

export function error(state, { chatId, errors }) {
    errors = fromJS(errors);

    return state
        .setIn([ 'items', chatId, 'state' ], 'ERROR')
        .setIn([ 'items', chatId, 'errors' ], errors);
}

export function finish(state, { chatId, assignee, messages }) {
    messages = fromJS(messages.reverse());
    assignee = fromJS(assignee);

    return state
        .setIn([ 'items', chatId, 'state' ], 'FINISHED')
        .setIn([ 'items', chatId, 'assignee' ], assignee)
        .setIn([ 'items', chatId, 'messages' ], messages);
}
